export const Top4 = () => {
    return (
        <svg width="144" height="175" viewBox="0 0 144 175" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M124.257 112.04L120.298 134.335H1.51343L3.84253 116.104L93.5129 3.23215H117.153L85.594 45.9655L33.655 111.924L124.257 112.04ZM122.51 3.23215L93.1636 172.308H65.7966L95.1433 3.23215H122.51Z"
                fill="url(#paint0_linear_1274_464)"
                fillOpacity="0.4"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1274_464"
                    x1="1.51343"
                    y1="82.3306"
                    x2="143.763"
                    y2="82.3306"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.763542" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
